<template>
    <div v-bind:class="{ 'theme-bdr--red':  !day }" dusk="day-select">
        <multiselect
            v-model="day"
            @input="updateParent"
            :options="dayOptions"
            label="label"
            track-by="value"
            :searchable="false"
            :show-labels="false"
            :allow-empty="false"
            placeholder="Select">
        </multiselect>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import DayOptions from '../options/day-options'

export default {
    props: {
        value: Object
    },
    data() {
        return {
            day: this.value
        }
    },
    computed: {
        dayOptions() {
            return DayOptions;
        }
    },
    watch: {
        value() {
            this.day = this.value;
        }
    },
    methods: {
        updateParent() {
            this.$emit('input', this.day);
        },
    },
    components: {
        Multiselect
    }
}
</script>

<style>

</style>
